import React, { useEffect, useRef, useState } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal  } from '@azure/msal-react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import { Link, useLocation } from 'react-router-dom';

import { accessHelper, accessHelperText, isEditPermitted } from '../util/checkAccess';
import { latestHeurigenUpdateDb, fetchHeurigen } from '../util/http-heurigen';
import { niceDate } from '../util/date';
import Openings from './Openings';

import "./Home.css"

function Heuriger (){
    const location = useLocation();        
    const { instance, accounts, inProgress } = useMsal();
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [heurigen, setHeurigen] = useState([]);


    const onGridReady = (params) => {
        setGridApi(params.api);
      };

    async function loadFromDb() {        
                    //let _heurigen = await fetchHeurigen();        
                    //if(_heurigen.status != 200) {
                        //console.log('heurigen-context ERROR error fetching heurigen: ', _heurigen.status);            
                    //} else {
            // console.log('heurigen-context fetched heurigen; sample: ', _heurigen.data[0]);
                        //console.log('heurigen-context: Fetched heurigen', _heurigen.data);
                        //setHeurigen(_heurigen.data);
                        //setDataLoaded(true);
                    //}        
    }

    const ts2Date = (params) => {
        return niceDate(new Date(params.value*1000), 2)
        
      };

    const [columnDefs] = useState([
        { field: "id", headerName: 'Id', flex: 1 },
        { field: "name", headerName: 'Name', flex: 5 },
        { field: "_ts", headerName: 'Letzte Änderung', flex: 1, cellRenderer: ts2Date}
    ]);
    
    const editPermission = isEditPermitted(location.state.currentAccount, location.state.id);

    useEffect(() => {        
        
        loadFromDb();

        if(gridApi && !dataLoaded) {
            gridApi.showLoadingOverlay();
          }
          if(gridApi && dataLoaded && heurigen?.length > 0) {
            gridApi.hideOverlay();
          }
    }, []); 

    return (
        // <ul className="list-group list-group-flush">
           //  <li className="list-group-item">bla1-n</li>
            // <li className="list-group-item">bla2-n</li>                        
        // </ul>
        <div className="home"> 
            <p className="text-left fw-bold pt-3">
                <Link to={'/'} relative="path">Editor für Heurigenöffnungszeiten</Link><br></br>
                Klosterneuburg: {location.state.id}                    
            </p>
            <p className="text-left">
                Berechtigungen: {accessHelperText(location.state.currentAccount)}<br></br>                                         
                Änderungen erlaubt für "{location.state.id}?": {editPermission ? 'Ja' : 'Nein'}
            </p>
                
            <div className="ag-theme-alpine" >
                <Openings id={location.state.id} currentAccount={location.state.currentAccount}></Openings>
            </div>
        </div>
    )
}

export default Heuriger;